// 仕様: Redux Toolkit公式推奨のカスタムフック
// https://redux-toolkit.js.org/tutorials/typescript#define-typed-hooks
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// TypeScript型付けされたuseDispatchとuseSelectorフック
// コンポーネント全体で使用する型安全なフック
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
